import { ThunkDispatch } from '@reduxjs/toolkit'
import { SocketEvent } from 'interface'
import { io, Socket } from 'socket.io-client'
import { getAccount } from './slices/Account'
import { EventAction, getEvent } from './slices/Event'
import * as News from './slices/News'
import * as Feedback from './slices/Feedback'
import { getOrganizer } from './slices/Organizer'
import { logout } from './slices/UI'
import type { RootState } from './store'

export class SocketClient {
  private dispatch: ThunkDispatch<any, any, any>
  private rootState: RootState
  static socket: Socket | null = null
  constructor(dispatch: ThunkDispatch<any, any, any>, rootState: RootState) {
    this.dispatch = dispatch
    this.rootState = rootState
  }
  connect() {
    const socket = io(
      process.env.NODE_ENV === 'development'
        ? 'http://' + window.location.hostname + ':5001'
        : '/',
      {
        path: '/game-io',
        auth: this.rootState.UI.auth,
        transports: ['websocket', 'polling'],
      }
    )
    SocketClient.socket = socket
    socket.on('connect_error', () => {
      socket.io.opts.transports = ['polling', 'websocket']
    })
    socket.on('connect', () => {
      process.env.NODE_ENV === 'development' &&
        console.log('Socket is connected')
      socket.on('disconnect', (r) => {
        console.log(r)
      })

      // systemUserIO
      socket.on('systemUserIO', (event: SocketEvent) => {
        process.env.NODE_ENV === 'development' && console.log(event)
        switch (event.action) {
          case 'created':
            this.dispatch(getAccount(event.id))
            break
          case 'deleted':
            break
          case 'updated':
            this.dispatch(getAccount(event.id))
            break
          case 'logout':
            this.dispatch(logout())
            break
          default:
            break
        }
      })

      // templateIO
      socket.on('templateIO', (event: SocketEvent) => {
        process.env.NODE_ENV === 'development' && console.log(event)
        switch (event.action) {
          case 'created':
            // this.dispatch(getQuizTemplate(event.id))
            break
          case 'deleted':
            break
          case 'updated':
            // this.dispatch(getQuizTemplate(event.id))
            break
          default:
            break
        }
      })
      // organizerIO
      socket.on('organizerIO', (event: SocketEvent) => {
        process.env.NODE_ENV === 'development' && console.log(event)
        switch (event.action) {
          case 'created':
            this.dispatch(getOrganizer(event.id))
            break
          case 'deleted':
            break
          case 'updated':
            this.dispatch(getOrganizer(event.id))
            break
          default:
            break
        }
      })
      // eventIO
      socket.on('eventIO', (event: SocketEvent) => {
        process.env.NODE_ENV === 'development' && console.log(event)
        switch (event.action) {
          case 'created':
            this.dispatch(getEvent(event.id))
            break
          case 'deleted':
            this.dispatch(EventAction.removeItem(Number(event.id)))
            break
          case 'updated':
            this.dispatch(getEvent(event.id))
            break
          default:
            break
        }
      })
      // newsIO
      socket.on('newsIO', (event: SocketEvent) => {
        process.env.NODE_ENV === 'development' && console.log(event)
        switch (event.action) {
          case 'created':
            this.dispatch(News.getOne(event.id))
            break
          case 'deleted':
            this.dispatch(News.NewsAction.removeItem(Number(event.id)))
            break
          case 'updated':
            this.dispatch(News.getOne(event.id))
            break
          case 'lock':
            this.dispatch(News.NewsAction.lockItem(event.id))
            break
          case 'unlock':
            this.dispatch(News.NewsAction.lockItem(0))
            break
          default:
            break
        }
      })
      // feedbackIO
      socket.on('feedbackIO', (event: SocketEvent) => {
        process.env.NODE_ENV === 'development' && console.log(event)
        switch (event.action) {
          case 'created':
            this.dispatch(Feedback.getOne(event.id))
            break
          case 'deleted':
            this.dispatch(Feedback.FeedbackAction.removeItem(Number(event.id)))
            break
          case 'updated':
            this.dispatch(Feedback.getOne(event.id))
            break
          case 'lock':
            this.dispatch(Feedback.FeedbackAction.lockItem(event.id))
            break
          case 'unlock':
            this.dispatch(News.NewsAction.lockItem(0))
            break
          default:
            break
        }
      })
    })
  }
  disconnect() {
    SocketClient.socket?.disconnect()
  }
}
